import React from 'react';
import './index.css';

class CommonBtn extends React.Component {
  constructor(props) {
    super(props);
  }
  render () {
    var style = {};
    var text = "";
    if (this.props.type) {
      if (this.props.type == "border") {
        style = {
          width: "90px",
          height: "30px",
          lineHeight: "30px",
          border: "1px solid var(--blue_highlight_color)",
          borderRadius: "2px",
          textAlign: "center",
          color: "var(--blue_highlight_color)",
          cursor: "pointer"
        };
      } else if (this.props.type == "common") {
        style = {
          width: "90px",
          height: "30px",
          lineHeight: "30px",
          borderRadius: "2px",
          textAlign: "center",
          cursor: "pointer",
          color: "var(--text_color)",
          background: "var(--shoal_color)"
        };
      }
    }
    if (this.props.text) {
      text = this.props.text;
    }
    if (this.props.newStyle) {
      for (var key in this.props.newStyle) {
        style[key] = this.props.newStyle[key];
      }
    }
    return (
      <div className='common_btn' onClick={this.btnClick.bind(this)} style={style}>
        {
          this.props.children
        }
        <div>
          {
            text
          }
        </div>
      </div>
    );
  }
  btnClick (e) {
    e.stopPropagation();
    if (this.props.btnClick) {
      this.props.btnClick();
    }
  }
}
export default CommonBtn;